import React from 'react';
import { X } from 'lucide-react';

const NewResolutionModal = ({ formData, setFormData, onSubmit, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800">Nouvelle Résolution</h2>
          <button onClick={onClose} data-testid="close-resolution-modal">
            <X size={24} className="text-gray-500 hover:text-gray-700" />
          </button>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.titre}
              onChange={(e) => setFormData({ ...formData, titre: e.target.value })}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Clef de répartition</label>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.clef_repartition}
              onChange={(e) => setFormData({ ...formData, clef_repartition: e.target.value })}
            >
              <option>Clef 1</option>
              <option>Clef 2</option>
              <option>Clef 3</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Type de majorité</label>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.type_majorite}
              onChange={(e) => setFormData({ ...formData, type_majorite: e.target.value })}
            >
              <option>Simple - Art. 24</option>
              <option>Absolue - Art. 25</option>
              <option>Double - Art. 26</option>
              <option>Unanimité</option>
            </select>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 pt-4">
            <button
              type="submit"
              className="w-full sm:flex-1 bg-[#00D3A8] hover:bg-[#00C7A1] text-white py-2 px-4 rounded-lg transition-colors"
              data-testid="submit-resolution-btn"
            >
              Créer
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full sm:flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewResolutionModal;
